import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import { httpGet } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { Environment } from "../utils/environments";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { ThemeContext } from "../context/ThemeContext";
export default function InterviewTicket() {
  const { getSingleTicket } = useContext(ThemeContext);
  const { currentUser } = useContext(AuthContext);
  const [singleTicket, setSingleTicket] = getSingleTicket;
  const [error, setError] = useState(undefined);
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "じぶん専用IT相談室 | サポート種別選択";
  }, []);
  useEffect(() => {
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", { state: { from: window.location.pathname } });
    } else {
      if (!singleTicket) {
        getTicketData();
      }
    }
  }, [currentUser]);
  /**
   * Naviagte to buy page
   */
  function buySingleTicket() {
    var productId = singleTicket[0].productId;
    navigate(`/buy?productId=${productId}`, {
      state: {
        productId: productId,
        from: window.location.pathname,
        staffInfo: { type: "interview" },
      },
    });
  }
  /**
   * get Interview Sale Data
   */
  const getTicketData = async () => {
    try {
      await httpGet({
        pathName: "nowonsale-products",
        queryParams: { productType: "INTERVIEW" },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        setSingleTicket(data.productList);
        console.log(data);
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      setError(error);
    }
  };
  return (
    <Fragment>
      {singleTicket && (
        <Grid item md={6} sm={12} xs={12}>
          <Card className="card-wrapper">
            <CardContent style={{ padding: "0" }}>
              <Box className="card-top-section">
                <Box className="card-icon-top">
                  <img src={"/images/reason02_circle.png"} />
                </Box>
                <Typography
                  variant="h4"
                  component="h4"
                  className="classification-heading font-cur"
                >
                  問診を希望する
                </Typography>
              </Box>
              <Box className="card-section-bottom">
                <Typography component={"h6"} className="sub-title">
                  トラブルの原因が分からない方やどうしていいか分からない方はこちら
                </Typography>
                <Typography
                  style={{
                    marginBottom: "50px",
                  }}
                >
                  どうしていいか分からないやどのチケットを購入すればいいかわからない方に、相談員に電話で相談できます。
                </Typography>
                <button
                  className="classification-btn full-width"
                  onClick={buySingleTicket}
                >
                  次へ
                </button>
                <Typography
                  className="text-center"
                  style={{
                    marginTop: "1rem",
                    color: "var(--dark-grey)",
                  }}
                >
                  ※決済画面に進みます
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Fragment>
  );
}
